import { httpAuth } from 'config/apiClient'
import endpoints from 'constants/endpoints'
import { ResultStatusRequest } from '../model/resultRequests'

/** Transport only. Redux callers own result identity, state reconciliation and failure presentation. */
export async function submitSubtaskResult(payload: Record<string, unknown>): Promise<boolean> {
  return !!(await httpAuth.post(endpoints.updateResults, payload))
}
export async function submitResultReview(payload: ResultStatusRequest): Promise<boolean> {
  const response = await httpAuth.put(endpoints.resultStatus, payload)

  return response.status === 200
}
